import { compareAsc, compareDesc } from "date-fns";
import { cloneDeep } from "lodash";
import { Schedule } from "../../PaymentContainerClient/dtos/ConfirmSuccessPaymentResponseDto";

export enum ScheduleChargeDateSortDirection {
    Asc = "ASC",
    Desc = "DESC",
}

export default function getSchedulesSortedByChargeDate(
    schedules?: Schedule[],
    sortDirection: ScheduleChargeDateSortDirection = ScheduleChargeDateSortDirection.Asc
): Schedule[] {
    return schedules
        ? cloneDeep(schedules).sort((scheduleA, scheduleB) =>
              sortDirection === ScheduleChargeDateSortDirection.Asc
                  ? compareAsc(
                        new Date(scheduleA.chargeDate),
                        new Date(scheduleB.chargeDate)
                    )
                  : compareDesc(
                        new Date(scheduleA.chargeDate),
                        new Date(scheduleB.chargeDate)
                    )
          )
        : [];
}
